import { CheckIcon, MinusIcon } from '@phosphor-icons/react';
import { useState } from 'react';
import { Group, Prompt } from '../../../../Types';
import AdminViewContent from '../../../Utility/AdminViewContent';
import TabHeadline from './TabHeadline';
import InfoButton from '../../../Utility/InfoButton';
import { PaginationListType } from '../../../../Types/PaginationParams';
import { groupService } from '../../../../Services/groupService';
import { Badge } from '../../../Utility/Badge';
import PaginatedView from '../../../Utility/PaginatedView';

interface GroupTabProps {
    prompt: Prompt;
    i18n: any;
    handlePromptUpdate: any;
}

function GroupTab({ prompt, i18n, handlePromptUpdate }: GroupTabProps) {
    const GRID_COLS = 'grid-cols-[minmax(157px,300px),minmax(157px,1fr)]';
    const [selectedGroups, setSelectedGroups] = useState<string[]>(prompt.groups || []);

    const handlePromptUpdate2 = (group: Group) => {
        const newGroups = selectedGroups.includes(group.identifier)
            ? selectedGroups.filter((identifier: string) => identifier !== group.identifier)
            : [...selectedGroups, group.identifier];

        setSelectedGroups(newGroups);
        handlePromptUpdate({ groups: newGroups });
    };

    return (
        <div className="w-full">
            <TabHeadline
                title={i18n.translate({
                    id: 'tabs.groups.title',
                    sourceName: 'Prompt',
                })}
            />
            <InfoButton configKey="groups" />

            <PaginatedView
                listType={PaginationListType.Groups}
                itemsFunction={groupService.getGroupsByPage}
                itemsPerPage={15}
                renderItem={(group: Group) => (
                    <AdminViewContent
                        key={group.identifier}
                        identifier={group.identifier}
                        gridCols={GRID_COLS}
                        cols={{
                            optionalCols: [
                                {
                                    content: group.title,
                                    onClick: () => handlePromptUpdate2(group),
                                },
                            ],
                            button: {
                                buttons: [
                                    {
                                        className: 'pointer-events-none',
                                        variant: selectedGroups.includes(group.identifier)
                                            ? 'primaryRound'
                                            : 'secondaryRound',
                                        icon: selectedGroups.includes(group.identifier) ? <CheckIcon /> : <MinusIcon />,
                                    },
                                ],
                            },
                        }}
                    />
                )}
            >
                {({ list, filter }) => (
                    <>
                        {prompt.isBasePrompt && (
                            <div className="mb-6">
                                <Badge variant="info">
                                    <div>
                                        <p>
                                            {i18n.translate({
                                                id: 'groups.isBasePrompt',
                                                sourceName: 'Prompt',
                                            })}
                                        </p>
                                    </div>
                                </Badge>
                            </div>
                        )}
                        {filter}
                        {list}
                    </>
                )}
            </PaginatedView>
        </div>
    );
}

export default GroupTab;
